import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiHome,
  FiBriefcase,
  FiCheckSquare,
  FiCalendar,
  FiUsers,
  FiSettings,
  FiBarChart2,
  FiExternalLink,
  FiFolder
} from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

interface MenuItem {
  path: string;
  icon: React.ReactNode;
  label: string;
  adminOnly?: boolean;
}

const menuItems: MenuItem[] = [
  { path: '/dashboard',  icon: <FiHome />,        label: 'Dashboard' },
  { path: '/cases',      icon: <FiBriefcase />,   label: 'Casos' },
  { path: '/tasks',      icon: <FiCheckSquare />, label: 'Tareas' },
  { path: '/hearings',   icon: <FiCalendar />,    label: 'Audiencias' },
  { path: '/portfolios', icon: <FiFolder />,      label: 'Carteras' },
  { path: '/reports',    icon: <FiBarChart2 />,   label: 'Reportes', adminOnly: true },
];

const adminItems: MenuItem[] = [
  { path: '/users',    icon: <FiUsers />,    label: 'Usuarios' },
  { path: '/settings', icon: <FiSettings />, label: 'Configuración' },
];

const Sidebar: React.FC = () => {
  const { user } = useAuth();
  const userRoles = user?.roles || [];
  const isAdmin = userRoles.includes('super_admin') || userRoles.includes('coordinador');

  const visibleMenuItems = menuItems.filter(item =>
    !item.adminOnly || isAdmin
  );

  return (
    <aside className="sidebar d-flex flex-column">
      {/* Logo */}
      <div className="sidebar-logo">
        <img
          src="/exia-crm-logo.svg"
          alt="EXIA CRM Jurídico"
          style={{ maxWidth: '180px', height: 'auto' }}
        />
      </div>

      {/* Navigation */}
      <ul className="sidebar-menu flex-grow-1">
        <li className="sidebar-menu-title">Navegación</li>

        {visibleMenuItems.map((item) => (
          <li key={item.path} className="sidebar-menu-item">
            <NavLink
              to={item.path}
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              <span className="icon">{item.icon}</span>
              {item.label}
            </NavLink>
          </li>
        ))}

        {isAdmin && (
          <>
            <li className="sidebar-menu-title">Administración</li>
            {adminItems.map((item) => (
              <li key={item.path} className="sidebar-menu-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <span className="icon">{item.icon}</span>
                  {item.label}
                </NavLink>
              </li>
            ))}
          </>
        )}
      </ul>

      {/* AS Software footer */}
      <div
        className="sidebar-footer"
        style={{
          padding: '12px 16px',
          borderTop: '1px solid rgba(255,255,255,0.08)',
          marginTop: 'auto'
        }}
      >
        <a
          href="https://assoftware.com.co"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            textDecoration: 'none',
            color: 'rgba(255,255,255,0.45)',
            fontSize: '11px',
            transition: 'color 0.2s'
          }}
          onMouseEnter={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.8)')}
          onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.45)')}
        >
          <span style={{ fontWeight: 600, letterSpacing: '0.5px' }}>
            AS Software
          </span>
          <FiExternalLink size={10} />
        </a>
        <div style={{ color: 'rgba(255,255,255,0.25)', fontSize: '10px', marginTop: '2px' }}>
          assoftware.com.co
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;